module.exports = __webpack_public_path__ + "img/beyond-collection.8f21d1d5.png";